import { KeyboardArrowRight } from '@mui/icons-material'
import { Typography } from '@mui/material'
import type { Route } from 'next'
import { useRouter } from 'next/navigation'
import { useCallback, useState } from 'react'
import { Trans } from 'react-i18next'
import { useLogger } from '../useLogger'
import { useVideoScale } from '../useVideoScale'

type Props = {
  videoId: string
  href?: Route
}

export const DetailButton = ({ videoId, href }: Props) => {
  const [hover, setHover] = useState(false)
  const { videoScale } = useVideoScale()
  const { toDetail } = useLogger()

  const router = useRouter()
  const handleClick = useCallback(() => {
    toDetail()
    router.push(href ?? `/videos/${videoId}`)
  }, [router, videoId, href, toDetail])

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        transition: 'all 0.2s cubic-bezier(0.3, 0.3, 0.3, 1)',
        color: 'white',
        textShadow: '0 0 2px rgba(0, 0, 0, .5)',
        opacity: hover ? 0.86 : 0.7,
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '4px',
      }}
    >
      <Typography variant='h2' fontSize='24px'>
        <Trans i18nKey='Detail Page' />
      </Typography>
      <KeyboardArrowRight sx={{ width: videoScale * 32, height: videoScale * 32 }} />
    </button>
  )
}
